function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_424",
  "data-name": "Group 424",
  transform: "translate(-976 -174)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_383",
  "data-name": "Group 383",
  transform: "translate(164 -146)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_10",
  "data-name": "Ellipse 10",
  cx: 21,
  cy: 21,
  r: 21,
  transform: "translate(812 320)",
  fill: "#eeeff3"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_259",
  "data-name": "Group 259",
  transform: "translate(2863.484 130.729)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_258",
  "data-name": "Group 258",
  transform: "translate(-1877.549 56.447)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_86",
  "data-name": "Path 86",
  d: "M-1858.7,67.422c-.251.243-.509.5-.781.76a1.761,1.761,0,0,1-2.351.058q-4.887-4.189-5.712-7.577a5.172,5.172,0,0,1-.177-1.231.851.851,0,0,1-.236-.059l-3.737-1.326a1.884,1.884,0,0,0-1.275,0l-3.317,1.179a1.91,1.91,0,0,0-1.26,1.791V71.395a1.894,1.894,0,0,0,2.535,1.784l2.042-.722a1.893,1.893,0,0,1,1.275,0l3.737,1.327a1.872,1.872,0,0,0,1.268,0l3.737-1.327a1.894,1.894,0,0,1,1.275,0l2.042.722a1.9,1.9,0,0,0,2.536-1.784V65.756C-1857.582,66.287-1858.12,66.84-1858.7,67.422Z",
  transform: "translate(1877.549 -57.936)",
  fill: "#5351fb"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_242",
  "data-name": "Group 242",
  transform: "translate(-1865.851 52.271)"
}, /*#__PURE__*/React.createElement("path", {
  id: "location",
  d: "M-1855.242,52.429a5.124,5.124,0,0,0-1.216-.147,3.937,3.937,0,0,0-.59,0,5.806,5.806,0,0,0-.951.147,4.929,4.929,0,0,0-3.361,3.037,4.541,4.541,0,0,0-.251.943,4.83,4.83,0,0,0-.059,1.084,4.042,4.042,0,0,0,.133,1.009q.608,2.488,4.194,5.557a1.287,1.287,0,0,0,1.725-.044c.2-.184.391-.376.575-.553a24.055,24.055,0,0,0,2.219-2.468,8.3,8.3,0,0,0,1.408-2.5,3.173,3.173,0,0,0,.17-1A5.215,5.215,0,0,0-1855.242,52.429Zm.118,5.484a1.652,1.652,0,0,1-.641.479,1.694,1.694,0,0,1-.693.147,1.68,1.68,0,0,1-.767-.184,1.693,1.693,0,0,1-.9-1.069,1.528,1.528,0,0,1-.074-.486,1.722,1.722,0,0,1,.627-1.333,1.743,1.743,0,0,1,1.113-.406,1.743,1.743,0,0,1,1.113.406,1.722,1.722,0,0,1,.627,1.333A1.747,1.747,0,0,1-1855.124,57.913Z",
  transform: "translate(1861.677 -52.271)",
  fill: "#5351fb"
}))));

var SvgLocationInsideCircle = function SvgLocationInsideCircle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLocationInsideCircle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/location-inside-circle.cbecda97.svg";
export { ForwardRef as ReactComponent };